export const LOCAL_STORAGE_INITIALIZE = 'LOCAL_STORAGE_INITIALIZE';
export const LOCAL_STORAGE_LOAD = 'LOCAL_STORAGE_LOAD';

export const initializeFromLocalStorage = () => ({ type: LOCAL_STORAGE_INITIALIZE });
export const loadFromStorage = data => ({ type: LOCAL_STORAGE_LOAD, data });
